import React from 'react';
import { Layout, Typography, Space } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import { EXECUTOR_API } from '../types';

const { Content } = Layout;
const { Title, Text } = Typography;

const ApiDocsPage: React.FC = () => (
  <Layout style={{ height: 'calc(100vh - 50px)', background: 'transparent', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

    <Content style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* Strip */}
      <div style={{
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
        padding: '14px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexShrink: 0,
      }}>
        <CodeOutlined style={{ fontSize: 16, color: '#1677ff' }} />
        <Title level={5} style={{ margin: 0 }}>API Reference</Title>
        <Text type="secondary" style={{ fontSize: 12 }}>OpenAPI · Executor backend</Text>
        <Space style={{ marginLeft: 'auto' }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {EXECUTOR_API}
          </Text>
        </Space>
      </div>

      {/* Swagger iframe — fills remaining height */}
      <iframe
        src={`${EXECUTOR_API}/docs`}
        title="Executor API — Swagger UI"
        style={{ flex: 1, width: '100%', border: 'none' }}
      />
    </Content>

  </Layout>
);

export default ApiDocsPage;
